import { animated, useSpring } from '@react-spring/web';
import { ReactElement, ReactNode, useEffect, useState } from 'react';
import { useMeasure } from 'react-use';

interface FlipCardProps {
  showBack: boolean;
  dyanamicHeight?: boolean;
  children: [ReactNode, ReactNode];
}

const FlipCard = (props: FlipCardProps): ReactElement => {
  const { children, dyanamicHeight, showBack } = props;

  const [flipped, set] = useState<boolean>(showBack);
  const [refFront, { height, width, left, right, top, bottom }] =
    useMeasure<HTMLDivElement>();
  const [refBack, { height: heightBack }] = useMeasure<HTMLDivElement>();

  const { transform, opacity } = useSpring({
    opacity: flipped ? 1 : 0,
    transform: `perspective(600px) rotateY(${flipped ? 180 : 0}deg)`,
    config: { mass: 5, tension: 500, friction: 80 },
  });

  useEffect(() => {
    set(showBack);
  }, [showBack]);

  return (
    <div
      style={{
        position: 'relative',
        height: flipped && dyanamicHeight ? heightBack : height,
      }}
    >
      <animated.div
        ref={refFront}
        style={{
          zIndex: flipped ? -1 : 1,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          opacity: opacity.to((o: any) => 1 - o),
          transform,
        }}
      >
        {children[0]}
      </animated.div>
      <animated.div
        ref={refBack}
        className="card-back"
        style={{
          height: dyanamicHeight ? undefined : height,
          overflowY: 'hidden',
          width,
          left,
          right,
          top,
          bottom: dyanamicHeight ? undefined : bottom,
          zIndex: flipped ? 1 : -1,
          opacity,
          transform: transform.to((t) => `${t} rotateY(180deg)`),
        }}
      >
        {children[1]}
      </animated.div>
    </div>
  );
};

export { FlipCard };
